//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "ScheduleCalendarScroll",
  components: {
    Icon24FillArrowLeft: () => import('@/assets/icons/Icon24FillArrowLeft.svg?inline'),
    Icon24FillArrowRight: () => import('@/assets/icons/Icon24FillArrowRight.svg?inline'),
    RoundButton: () => import("@/components/common/RoundButton"),
  },
  data() {
    return {
      id: '',
      scroll: null,
      scrollLeft: 0,
      scrollWidth: 0,
      width: 0,
    }
  },
  computed: {
    ...mapGetters({
      currentDay: 'schedule-calendar/currentDay',
      today: 'schedule-calendar/today',
      filteredDays: 'schedule-calendar/filteredDays',
    }),
    showNextButton() {
      return this.scrollLeft + this.width !== this.scrollWidth && this.scrollWidth > this.width
    },
    showPreviewButton() {
      return this.scrollLeft > 0
    }
  },
  watch: {
    filteredDays() {
      if (!process.server) {
        this.scroll?.removeEventListener('scroll', this.handleScrollLeft, null)
        this.id = `schedule-calendar-scroll-${Math.random().toString(36).substring(2, 15)}`
        this.width = this.$el.clientWidth;
        this.$nextTick(() => {
          this.scroll = document.querySelector(`#${this.id}`)
          this.scrollWidth = this.scroll?.scrollWidth || 0
          this.scroll?.addEventListener('scroll', this.handleScrollLeft, null)
        })
        this.$store.dispatch('schedule-calendar/setCurrentDay', this.filteredDays[0])
      }
    }
  },
  mounted() {
    this.id = `schedule-calendar-scroll-${Math.random().toString(36).substring(2, 15)}`
    this.width = this.$el.clientWidth;
    this.$nextTick(() => {
      this.scroll = document.querySelector(`#${this.id}`)
      this.scrollWidth = this.scroll?.scrollWidth || 0
      this.scroll?.addEventListener('scroll', this.handleScrollLeft, null)
    })
    this.$store.dispatch('schedule-calendar/setCurrentDay', this.filteredDays[0])
  },
  beforeDestroy() {
    this.scroll?.removeEventListener('scroll', this.handleScrollLeft, null)
  },
  methods: {
    handleScrollLeft(e) {
      this.scrollLeft = e.target.scrollLeft
      this.scrollWidth = e.target.scrollWidth
    },
    classList({day}) {
      return [
        {'schedule-calendar-day--today': this.today === day},
        {'schedule-calendar-day--current': this.currentDay === day},
        {'schedule-calendar-day--weekend': this.weekend(day)}
      ]
    },
    weekend(day) {
      return day === this.$moment.unix(day).day(0).unix() ||
        day === this.$moment.unix(day).day(6).unix()
    },
    preview() {
      this.scroll.scrollLeft = this.scroll.scrollLeft - this.width + 100
    },
    next() {
      this.scroll.scrollLeft = this.scroll.scrollLeft + this.width - 100
    },
  }
}
